import { LeadStatus } from '@inpart-io/padme-iap';

import {
    LeadOnlyNextStatus,
    LeadOnlyStatusSetValues,
    type LeadStatusSet,
    NextStatus,
    StatusSetValues
} from '@/components/lead-profile/components/lead-status/constants/lead.status.constants';
import { store } from '@/store/index';
import { SESSION_MODULE } from '@/store/session-module';
import { USE_DEAL_WORKFLOW } from '@/store/session-module/getters';

export class LeadStatusService {
    public getStatusSetValues(key: LeadStatusSet): LeadStatus[] {
        return this.currentStatusSetValues().get(key);
    }

    public getNextStatus(key: LeadStatus): Array<LeadStatus | LeadStatusSet> {
        return this.currentNextStatus().get(key);
    }

    public getValidatedStatus(): LeadStatus {
        return this.useDealWorkflow() ? LeadStatus.CLOSED : LeadStatus.QUALIFIED;
    }

    public getLeadStatusToFilterByStage(): LeadStatus[] {
        return this.useDealWorkflow() ? [LeadStatus.DRAFT, LeadStatus.TRIAGE] : [LeadStatus.DRAFT, LeadStatus.TRIAGE, LeadStatus.QUALIFIED];
    }

    private useDealWorkflow(): boolean {
        return store.getters[`${SESSION_MODULE}/${USE_DEAL_WORKFLOW}`];
    }

    private currentStatusSetValues(): Map<LeadStatusSet, LeadStatus[]> {
        return this.useDealWorkflow() ? StatusSetValues : LeadOnlyStatusSetValues;
    }

    private currentNextStatus(): Map<LeadStatus, Array<LeadStatus | LeadStatusSet>> {
        return this.useDealWorkflow() ? NextStatus : LeadOnlyNextStatus;
    }
}
export const leadStatusService = new LeadStatusService();
